/* eslint-disable */ import { assertNumber, attributeSelectionComponent, dimensionIndicatorComponent, distanceDimensionComponent, memoEval } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
import { BendDirection, BendOrientation } from '../model/index.js';
export const customBendComponents = [
    attachComponent.withComponent(attributeSelectionComponent, 'orientation', true).withEntity('CustomBend').attach(memoEval((self)=>[
            self.orientation
        ], (orientation)=>({
            value: orientation,
            options: [
                {
                    label: 'Horizontal',
                    value: 'Horizontal'
                },
                {
                    label: 'Vertical',
                    value: 'Vertical'
                }
            ]
        })), (state)=>{
        BendOrientation.assert(state.value);
        return {
            orientation: state.value
        };
    }),
    attachComponent.withComponent(attributeSelectionComponent, 'direction', true).withEntity('CustomBend').attach(memoEval((self)=>[
            self.direction
        ], (direction)=>({
            value: direction,
            options: [
                {
                    label: 'Front',
                    value: 'Front'
                },
                {
                    label: 'Back',
                    value: 'Back'
                }
            ]
        })), (state)=>{
        BendDirection.assert(state.value);
        return {
            direction: state.value
        };
    }),
    attachComponent.withComponent(distanceDimensionComponent, 'bendStartLength', true).withEntity('CustomBend').attach(memoEval((self)=>[
            self.$startLengthMin,
            self.$startLengthMax,
            self.startInnerLength
        ], ($startLengthMin, $startLengthMax, startInnerLength)=>({
            min: $startLengthMin,
            max: $startLengthMax,
            value: startInnerLength
        })), (state)=>{
        assertNumber(state.value);
        return {
            startInnerLength: state.value
        };
    }),
    attachComponent.withComponent(distanceDimensionComponent, 'bendEndLength', true).withEntity('CustomBend').attach(memoEval((self)=>[
            self.$endLengthMin,
            self.$endLengthMax,
            self.endInnerLength
        ], ($endLengthMin, $endLengthMax, endInnerLength)=>({
            min: $endLengthMin,
            max: $endLengthMax,
            value: endInnerLength
        })), (state)=>{
        assertNumber(state.value);
        return {
            endInnerLength: state.value
        };
    }),
    attachComponent.withComponent(dimensionIndicatorComponent, 'bendStart', true).withEntity('CustomBend').withFilter(()=>({
            viewStates: [
                '3d'
            ]
        })).attach(memoEval((self)=>[
            self.$startIndicatorEndX,
            self.$startIndicatorEndY,
            self.$startIndicatorStartZ,
            self.$startIndicatorEndZ,
            self.$sizeIndicatorExtrusionX,
            self.$sizeIndicatorExtrusionY,
            self.$indicatorLabelFontSize
        ], ($startIndicatorEndX, $startIndicatorEndY, $startIndicatorStartZ, $startIndicatorEndZ, $sizeIndicatorExtrusionX, $sizeIndicatorExtrusionY, $indicatorLabelFontSize)=>({
            startX: 0,
            startY: 0,
            endX: $startIndicatorEndX,
            endY: $startIndicatorEndY,
            startZ: $startIndicatorStartZ,
            endZ: $startIndicatorEndZ,
            extrusionX: $sizeIndicatorExtrusionX,
            extrusionY: $sizeIndicatorExtrusionY,
            extrusionLineDashed: true,
            dashScale: 500,
            arrowHeadType: 'CONE',
            arrowHeadSize: 6,
            labelFontSize: $indicatorLabelFontSize
        }))),
    attachComponent.withComponent(dimensionIndicatorComponent, 'bendEnd', true).withEntity('CustomBend').withFilter(()=>({
            viewStates: [
                '3d'
            ]
        })).attach(memoEval((self)=>[
            self.$endIndicatorStartX,
            self.$endIndicatorStartY,
            self.$endIndicatorEndX,
            self.$endIndicatorEndY,
            self.$endIndicatorStartZ,
            self.$endIndicatorEndZ,
            self.$sizeIndicatorExtrusionX,
            self.$sizeIndicatorExtrusionY,
            self.$indicatorLabelFontSize
        ], ($endIndicatorStartX, $endIndicatorStartY, $endIndicatorEndX, $endIndicatorEndY, $endIndicatorStartZ, $endIndicatorEndZ, $sizeIndicatorExtrusionX, $sizeIndicatorExtrusionY, $indicatorLabelFontSize)=>({
            startX: $endIndicatorStartX,
            startY: $endIndicatorStartY,
            endX: $endIndicatorEndX,
            endY: $endIndicatorEndY,
            startZ: $endIndicatorStartZ,
            endZ: $endIndicatorEndZ,
            extrusionX: $sizeIndicatorExtrusionX,
            extrusionY: $sizeIndicatorExtrusionY,
            extrusionLineDashed: true,
            dashScale: 500,
            arrowHeadType: 'CONE',
            arrowHeadSize: 6,
            labelFontSize: $indicatorLabelFontSize
        })))
];

//# sourceMappingURL=custom-bend.js.map